import {
    DeleteFolderDocument,
    DeleteFolderMutation,
} from '../graphql/__generated__/DeleteFolderMutation.interface';
import { FolderStore } from 'owa-folders';
import { MailFolder } from 'owa-graph-schema';
import deleteFolderStoreUpdate from 'owa-mail-actions/lib/triage/deleteFolderStoreUpdate';
import * as undoActions from 'owa-mail-undo';
import { action } from 'satcheljs/lib/legacy';
import {
    deleteFoldersFromFolderTable,
    getAllSubFolderIds,
    moveFolderToParentFolder,
    removeFolderFromParentFolder,
} from 'owa-folders';
import { getApolloClient } from 'owa-apollo';
import { getMailboxInfoForFolderId } from 'owa-folders';

type DeleteFolderResult = DeleteFolderMutation['deleteFolder'];

export default action('deleteFolder')(async function deleteFolder(
    folders: FolderStore,
    folderId: string,
    softDelete: boolean,
    deletedItemsFolderId: string
) {
    // Only need to worry about removing the top-most folder from its parent's
    // list of children
    const folderToDelete: MailFolder = folders.folderTable.get(folderId);

    undoActions.clearLastUndoableAction();

    removeFolderFromParentFolder(folders, folderToDelete);

    const folderIdsToDelete = getAllSubFolderIds(folderToDelete.FolderId.Id, folders);

    // Notify list view component to update the list view store
    deleteFolderStoreUpdate(folderIdsToDelete);

    // In case of soft delete, remove the folder from the foldertable otherwise we move the fodler to the deleted items folder of corresponding mailbox
    if (softDelete) {
        deleteFoldersFromFolderTable(folders, folderIdsToDelete);
    } else {
        moveFolderToParentFolder(folders, folderToDelete, deletedItemsFolderId);
    }

    await exportedHelperFunctions.invokeDeleteFolderMutation(folderId, softDelete);
});

const invokeDeleteFolderMutationFn = async function invokeDeleteFolderMutation(
    folderId: string,
    softDelete: boolean
): Promise<DeleteFolderResult> {
    const client = await getApolloClient();

    // TODO: VSO 11909: Handle undo for destructive mail actions
    const result = await client.mutate({
        variables: {
            id: folderId,
            disposalType: softDelete ? 'SoftDelete' : 'MoveToDeletedItems',
            mailboxInfo: getMailboxInfoForFolderId(folderId, false /* routeToAuxIfAuxArchive */),
        },
        mutation: DeleteFolderDocument,
    });

    return result?.data?.deleteFolder;
};

/**
 * This helper method is exported so it can be mocked for unit testing
 */
export const exportedHelperFunctions = {
    invokeDeleteFolderMutation: invokeDeleteFolderMutationFn,
};
